import { themeColors } from "../../config.js";
export const modalStyles = {
  frame: {
    flex: 1,
    display: "flex",
    alignSelf: "stretch",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    fontFamily: "roboto",
    fontSize: 15,
    color: themeColors.transparentWhite,
    backgroundColor: themeColors.transparentBlack,
  },
  fileSelector: {
    display: "hidden",
  },
  info: {
    display: "flex",
    alignSelf: "stretch",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    padding: 3,
  },
  label: {
    display: "flex",
    alignSelf: "stretch",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: "bold",
    padding: 20,
  },
  input: {
    fontSize: 12,
    width: 80,
    height: 16,
    borderRadius: 5,
    fontFamily: "roboto",
    textShadow: "0 0 5px white",
    padding: 2,
    outline: "none",
    border: "none",
    backgroundColor: themeColors.optionColor,
    color: themeColors.transparentWhite,
    marginLeft: 5,
  },
  button: {
    margin: 10,
    padding: 10,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: themeColors.transparentBlack,
    alignSelf: "center",
  },
};
